

let segmentedProfessions = () => {
    // fetch url
    fetch(`${document.location.origin}/wp-content/themes/shifts/config.json`)
        .then(response => response.json())
        .then(config => {

          let configData = {};

          configData.coreApiUrl =`https://${document.querySelector("html").dataset.core}.ayahealthcare.com` || `https://api.ayahealthcare.com`;
          let envUrl = configData.coreApiUrl;

            // const segmentedProfessionURL = `${envUrl}/AyaHealthCareWeb/job/ProfessionsWithTypes`;
            const shiftsDataURL = `${envUrl}/Shifts/Jobs/Filters`;
            // const specialtyStateURL = `${envUrl}/AyaHealthcareWeb/job/joblookups`;

            // grab the list elements that we'll fill later
            const professionsDropdown = document.querySelector('.professions-dropdown .menu');
            const specialtiesDropdown = document.querySelector('.specialties-dropdown .menu');
            // console.log(specialtiesDropdown);
            // const locationsDropdown = document.querySelector('.locations-dropdown .menu');
            //const shiftsDropdown = document.querySelector('.shifts-dropdown');

            // hook up the jobs search button
            const searchButton = document.querySelector('.search-jobs');
            // searchButton.addEventListener('click', searchJobs);

            

            function filterParentProfessionDropdowns(data) {

                // create empty array to fill later
                let parentProfessionArray = data;

                // fill the array with all the professionTypeNames
                // data.map((item) => {
                //     parentProfessionArray.push(item.professionTypeName);
                // });

                // filter out the duplicates using Set
                // parentProfessionArray = [...new Set(parentProfessionArray)];

                // add the elements to the list item
                parentProfessionArray.map((item) => {
                    // if (item !== 'Locum Tenens') {
                        professionsDropdown.insertAdjacentHTML('beforeEnd', `<div class="item filter-profession">${item.name}<div class="menu" data-parentname="${item.name}" data-parent="${item.id}"></div></div>`);
                    // }
                });

            }

            function addProfessionDropdowns(data) {

                // grab all the profession <li> elements defined on the page
                let professions = document.querySelectorAll('.filter-profession .menu');

                data.map((item) => {
                    professions.forEach(profession => {
                        // match the professionTypeName of each item to the data-branch parent
                        if (item.typeId.toString() === profession.dataset.parent) {
                            profession.insertAdjacentHTML('beforeEnd', `<div class="item" data-value="${item.id}" data-parent="${item.typeId}">${item.name}</div>`);
                            // console.log(item.name)
                        }
                    });

                    // professions.forEach(menu => {
                    //     menu.insertAdjacentHTML('afterBegin', `Close`);
                    // });
                });
            }

            function filterSpecialties(selectedId) {

                // grab all the specialty items from the specialtyDropdowns
                let getCurrentSpecialties = specialtiesDropdown.querySelectorAll('.item');

                getCurrentSpecialties = Array.from(getCurrentSpecialties);

                // create an array so we can iterate through it using .map
                getCurrentSpecialties.map((item) => {

                    // grab the data-parent value then split the list so we can work with indexOf
                    let parentBranch = item.getAttribute("data-parent");
                    parentBranch = parentBranch.split(",");

                    // in order to match directly (matching 11 when looking for 1), we'll use indexOf to remove specialties that don't match the parent-branch id
                    if (parentBranch.indexOf(`${selectedId}`) === -1) {
                        item.remove();
                    }
                });

            }


            // if (sessionStorage.getItem("isLocums") == 'true') {
            //     locumsFields(true)
            // } else {
            //     locumsFields(false)
            // }

            let handleProfessionClick = function (e) {

                // if (e.key !== 'Enter') {
                //     return;
                // }

                // let professionId = this.dataset.id;
                let professionId = this.dataset.value;
                let professionType = this.dataset.parent;
                // console.log(professionId);

                
                // if (professionType === 'Locum Tenens') {
                //     locumsFields(true)
                //     // locumFields = Array.from(locumFields);
                //     // locumFields.map((item) => { item.classList.remove('hide-el'); });
                //     // nonLocumFields = Array.from(nonLocumFields);
                //     // nonLocumFields.map((item) => { item.classList.add('hide-el'); });
                //     // sessionStorage.setItem("isLocums", true);
                // } else {
                //     locumsFields(false)
                //     // locumFields = Array.from(locumFields);
                //     // locumFields.map((item) => { item.classList.add('hide-el'); });
                //     // nonLocumFields = Array.from(nonLocumFields);
                //     // nonLocumFields.map((item) => { item.classList.remove('hide-el'); });
                //     // sessionStorage.setItem("isLocums", false);
                // }

                // remove any (multi)selected specialties
                let activeSpecialties = document.querySelector('.specialties-dropdown').querySelectorAll('.visible');

                if (activeSpecialties) {
                    activeSpecialties.forEach(specialty => {
                        specialty.remove();
                    });
                }

                // reset specialties dropdown in the event the user is switching professions after selecting a specialty
                let currentSpecialties = specialtiesDropdown.querySelectorAll('.item');
                currentSpecialties = Array.from(currentSpecialties);
                currentSpecialties.map((item) => { item.remove(); });

                // console.log(specialtyData)

                // repopulate the list
                addSpecialtiesDropdowns(specialtyData);

                document.querySelector('.specialties-dropdown .text').innerHTML = '';

                // remove the specialties that don't match the selected profession
                // console.log('foo', professionId)
                filterSpecialties(professionId);

                // change the name
                displayNameChange(e.target, professionId);

                return professionId;

            }

            // function handleMenuCloseClick(el) {

            //     // let thisMenu = e.closest('.menu');
            //     let thisMenu = el;
            //     thisMenu.classList.remove('visible')
            //     thisMenu.classList.add('hidden')
            // }

            function handleSpecialtyClick(e) {

                let linkId = this.dataset.id;
            }

            // selectedLocationsArray = [];

            function handleLocationClick(e) {

                let linkId = this.dataset.id;
            }

            function handleShiftsClick(e) {
            }

            function addSpecialtiesDropdowns(data) {

                // create empty array to fill later
                let specialtiesArray = data;

                // console.log(specialtiesArray)

                // fill the array with all the professionTypeNames
                // data.map((item) => {
                //     specialtiesArray.push(item);
                // });

                // add the elements to the list item
                specialtiesArray.map((item) => {
                    specialtiesDropdown.insertAdjacentHTML('beforeEnd', `<div class="item filter-specialty" data-value="${item.id}" data-parent="${item.professionExpertiseCodes}">${item.name}</div>`);
                });

                let specialtyItems = Array.from(document.querySelectorAll('.filter-specialty'));
                specialtyItems.map((item) => { item.addEventListener('click', handleSpecialtyClick); });

            }

            function displayNameChange(e, id) {
                // console.log(e);
                // change the display of the button to the currently selected profession
                // let linkTitle = e.innerHTML;
                // let closestDropdown = e.closest('.dropdown-container');
                // closestDropdown.querySelector('span').innerHTML = linkTitle;
                // closestDropdown.querySelector('a.ui.label').setAttribute("data-id", e.dataset.id)
                // $('.professions-dropdown a.ui.label').attr('data-id', id);

            }

            // function addLocationsDropdown(stateData, cityData) {

            //     let stateLocationsArray = [];
            //     let cityLocationsArray = [];

            //     stateData.map((item) => {
            //         // target just usa and original 52 states
            //         if (item.id < 53) {
            //             stateLocationsArray.push(item);
            //         }
            //     });

            //     cityData.map((item) => {
            //         cityLocationsArray.push(item);
            //     });


            //     // add the elements to the list item
            //     stateLocationsArray.map((item) => {
            //         locationsDropdown.insertAdjacentHTML('beforeEnd', `<div class="item filter-location" data-value="${item.id}">${item.name}</div>`);
            //     });

            //     cityLocationsArray.map((item) => {
            //         locationsDropdown.insertAdjacentHTML('beforeEnd', `<div class="item filter-location" data-value="${item.city},%20${item.state}">${item.city}, ${item.state}</div>`);
            //     });

            //     let locationsItems = Array.from(locationsDropdown.querySelectorAll('.item'));
            //     locationsItems.map((item) => { item.addEventListener('click', handleLocationClick); });

            // }

            //let shiftsItems = Array.from(shiftsDropdown.querySelectorAll('.item'));
            //shiftsItems.map((item) => { item.addEventListener('click', handleShiftsClick); });


            let specialtyData;
            let stateData;
            let cityData;

            // make the API call
            fetch(shiftsDataURL)
                .then(res => res.json())
                .then(data => {

                    filterParentProfessionDropdowns(data.professionTypes);
                    addProfessionDropdowns(data.professions);
                    // hook up event listeners for each profession item
                    let professionItems = Array.from(document.querySelectorAll('.filter-profession .menu .item'));
                    professionItems.map((item) => { item.addEventListener('click', handleProfessionClick); });
                    // professionItems.map((item) => { item.addEventListener('keydown', handleProfessionClick); });
                    // professionItems.map((item) => { item.addEventListener('keydown', function(e) {
                    //     if (e.key === 'Enter') {
                    //         console.log('ENTER')
                    //         handleProfessionClick
                    //     }
                    // })}); 

                  

                    let professionMenuCloseButton = Array.from(document.querySelectorAll('.filter-profession .menu'));
                    professionMenuCloseButton.map((item) => { 
                        item.insertAdjacentHTML('afterbegin', `<span></span>`);
                        item.addEventListener('click', function() {
                            item.classList.remove('visible')
                            item.classList.add('hidden')
                        });  
                    });


                    specialtyData = data.expertises;
                    addSpecialtiesDropdowns(specialtyData);
                    let specialtyItems = Array.from(document.querySelectorAll('.filter-specialty'));
                    specialtyItems.map((item) => { item.addEventListener('click', handleSpecialtyClick) });

                }).catch(err => {
                    console.error('Error: ', err);
                });

            // make the second API call
            // fetch(specialtyStateURL)
            //     .then(res => res.json())
            //     .then(data => {

            //         specialtyData = data.expertises;
            //         stateData = data.states;
            //         cityData = data.cities;

            //         // addSpecialtiesDropdowns(specialtyData);
            //         // addLocationsDropdown(stateData, cityData);

            //         // hook up event listeners for each specialty item
            //         let specialtyItems = Array.from(document.querySelectorAll('.filter-specialty'));
            //         specialtyItems.map((item) => { item.addEventListener('click', handleSpecialtyClick) });

            //     }).catch(err => {
            //         console.error('Error: ', err);
            //     });

        });

        // // initialize the semantic-ui dropdown implementation;
        // document.addEventListener('DOMContentLoaded', function () {
        //     $('.professions-dropdown').dropdown();
        //     $('.specialties-dropdown').dropdown({
        //         fullTextSearch: true
        //     });
        //     $('.locations-dropdown').dropdown({
        //         fullTextSearch: true
        //     });
        // });
    // end fetch
}

export { segmentedProfessions };


